import { localePaymentType } from '../en-US'

/* eslint-disable max-len */
export const payment: localePaymentType = {
  withdrawalSuccess: 'Retirada ordenada con éxito',
  noData: 'Sin datos',
  date: 'Fecha',
  amount: 'Cantidad',
  bonus: 'Bonificación',
  type: 'Tipo',
  status: 'Estado',
  promocodeSuccess: 'Código promocional activado correctamente',
  payoutCanceledSuccess: 'El pago se ha cancelado correctamente',

  transactionStatuses: {
    ALL: 'Todos',
    COMPLETED: 'Completado',
    OPEN: 'Abierto',
    IN_PROCESS: 'Esperando',
    REJECTED: 'Rechazado',
  },

  paymentStatuses: {
    10: 'Comenzado',
    20: 'Solicitado',
    21: 'Aprobado',
    22: 'Aprobación fallida',
    27: 'Proceso manual requerido',
    30: 'Éxito',
    40: 'Fallido',
    45: 'Expirado',
  },
}
